import { FormEvent, useContext, useState } from 'react';

import { ClientError } from '../../api';
import { ApiContext, CoreContext } from '../../providers';
import { setError } from '../../state';

export type Event =
    | 'initAltinnLoginFlow'
    | 'showTargetElement'
    | 'idPortenLogin'
    | 'onescoreLogin'
    | 'redirect';

/**
 * TODO: Refactor this by moving form related code to actual form components.
 */
export const useFormEvents = (formEvent: Event, fieldValues: any) => {
    const [showLoader, setShowLoader] = useState<boolean>(false);

    const { Upscore, Onescore } = useContext(ApiContext);
    const { settings, store } = useContext(CoreContext);

    const formEvents: {
        [key in Event]: (event: FormEvent) => Promise<void>;
    } = {
        onescoreLogin: async (event: FormEvent) => {
            event.preventDefault();

            const formValues: { personNumber: string; phoneNumber: string } =
                fieldValues;

            try {
                const processId = await Onescore.getProcessId({
                    data: {
                        personNumber: formValues.personNumber,
                        phoneNumber: formValues.phoneNumber,
                        gjeldsConsent: false,
                    },
                });

                window.location.href = `${window.location.origin}/altinn-process?processId=${processId}`;
            } catch (error: any) {
                store.dispatch(setError('general'));
                throw new ClientError(error.message, {
                    category: 'Upscore API',
                    type: 'general',
                    error,
                });
            }
        },
        initAltinnLoginFlow: async (event: FormEvent) => {
            event.preventDefault();

            const params = new URLSearchParams(window.location.search);

            sessionStorage.setItem(
                'externalId',
                params.get('externalId') || '',
            );
            sessionStorage.setItem(
                'organizationNumbers',
                params.get('orgNr') || '',
            );
            sessionStorage.setItem(
                'privateData',
                !params.get('privateData') ||
                    params.get('privateData') === 'true'
                    ? 'true'
                    : '',
            );
            sessionStorage.setItem(
                'redirectUrl',
                params.get('redirectUrl') || '',
            );

            sessionStorage.setItem(
                'callbackUrl',
                params.get('callbackUrl') || '',
            );

            window.location.href = `https://id.knowledgebase.no/auth?client_id=6f9366d8f1db037c13a687a6b383f3e8&locale=nb&scope=tax_data_pdf,income,info&callback_uri=${
                window.location.origin
            }/altinn-process${
                window.location.origin.includes('localhost') ? '&test=true' : ''
            }`;
        },
        showTargetElement: async (event: FormEvent) => {
            event.preventDefault();
        },

        /**
         * idPortenLogin expects data-idporten-redirecturl to be present on
         * form's props - this can be set in Storybook Form (redner settings)
         * props
         */
        idPortenLogin: async (event: any) => {
            event.preventDefault();

            const params = new URLSearchParams(window.location.search);

            sessionStorage.setItem(
                'externalId',
                params.get('externalId') || '',
            );
            sessionStorage.setItem(
                'organizationNumbers',
                params.get('orgNr') || '',
            );
            sessionStorage.setItem(
                'privateData',
                !params.get('privateData') ||
                    params.get('privateData') === 'true'
                    ? 'true'
                    : '',
            );
            sessionStorage.setItem(
                'redirectUrl',
                params.get('redirectUrl') || '',
            );

            sessionStorage.setItem(
                'callbackUrl',
                params.get('callbackUrl') || '',
            );

            const idPortenRedirectUrl = event.target.attributes.getNamedItem(
                'data-idporten-redirecturl',
            ).value;

            const idPortenAuthUrl = await Upscore.getAuthIdportenAuthurl({
                params: {
                    redirectUrl: `${window.location.origin}/${idPortenRedirectUrl}`,
                },
            }).then((data) => data.authUrl);

            window.location.href = idPortenAuthUrl;
        },

        redirect: async (event: any) => {
            event.preventDefault();

            const redirecPath =
                event.target.attributes.getNamedItem('data-redirect').value;

            window.location.href = `${window.location.origin}/${redirecPath}`;
        },
    };

    return { onSubmit: formEvents[formEvent], showLoader };
};
